import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import axios from "axios"
import { PageSEO } from "@/components/page-seo"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { API_BASE } from "@/config/api"
import { toast } from "sonner"

const API = API_BASE

export default function Book() {
  const { t, i18n } = useTranslation()
  const { slug } = useParams()
  const [practice, setPractice] = useState(null)
  const [slots, setSlots] = useState([])
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [selected, setSelected] = useState(null)
  const [done, setDone] = useState(false)
  const dateLocale = i18n.language?.startsWith("hu") ? "hu-HU" : "ro-RO"

  useEffect(() => {
    if (!slug) return
    axios.get(`${API}/public/practices/${slug}`).then((r) => setPractice(r.data)).catch(() => {})
    axios.get(`${API}/public/practices/${slug}/slots`).then((r) => setSlots(r.data.slots || [])).catch(() => {})
  }, [slug])

  const submit = async (e) => {
    e.preventDefault()
    if (!selected) return toast.error(t("public.book.toastPickSlot"))
    try {
      await axios.post(`${API}/public/practices/${slug}/book`, {
        name,
        email,
        slot_start: selected.start,
        slot_end: selected.end,
      })
      setDone(true)
      toast.success(t("public.book.toastBooked"))
    } catch {
      toast.error(t("public.book.toastFailed"))
    }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <PageSEO seoKey="book" />
      <div className="max-w-md w-full rounded-2xl border border-border bg-card p-8">
        <h1 className="font-display text-2xl tracking-tight font-medium">
          {practice?.name || t("public.book.titleFallback")}
        </h1>
        <p className="text-sm text-muted-foreground mt-2">{t("public.book.subtitle")}</p>
        {!done ? (
          <form className="mt-6 space-y-4" onSubmit={submit}>
            <div>
              <Label>{t("public.book.name")}</Label>
              <Input value={name} onChange={(e) => setName(e.target.value)} required className="mt-1" />
            </div>
            <div>
              <Label>{t("public.book.email")}</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" />
            </div>
            <div className="grid grid-cols-2 gap-2 max-h-48 overflow-y-auto">
              {slots.map((s) => (
                <button
                  key={s.start}
                  type="button"
                  onClick={() => setSelected(s)}
                  className={`text-sm py-2 rounded-lg border transition-colors ${
                    selected?.start === s.start ? "border-accent bg-accent/10" : "border-border hover:bg-muted"
                  }`}
                >
                  {new Date(s.start).toLocaleString(dateLocale, {
                    weekday: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </button>
              ))}
              {!slots.length && (
                <p className="text-sm text-muted-foreground col-span-2">{t("public.book.noSlots")}</p>
              )}
            </div>
            <Button type="submit" className="w-full rounded-full">
              {t("public.book.confirm")}
            </Button>
          </form>
        ) : (
          <p className="mt-6 text-sm text-accent">{t("public.book.success", { email })}</p>
        )}
      </div>
    </div>
  )
}
